<template lang="pug">
div(v-if='plans' class='relative text-sm')
  div(v-if='isLoading' class='bg-black opacity-50 absolute top-0 bottom-0 w-full z-10 flex justify-center items-center')
    div(class='loader !border-[7px] !w-12 !h-12')

  p(class='mb-1')
    | Protect your purchase - sold by &nbsp;
    img(:src='"/images/extend/logo.svg"' alt='Extend' class='h-3')
    | &nbsp;
    a(v-if='planLink' :href='planLink' target='_blank' class='text-xs text-black underline ml-1') Learn More

  div(class='is-small')
    BaseFormSelect(
      v-model='selectedPlan'
      aria-label='Change Protection Plan'
      :name='`plans_${item.id}`'
      :options='planOptions'
    )
</template>

<script lang="ts" setup>
const { $extend } = useNuxtApp()
const notifications = useNotifications()

const { item } = defineProps<{
  item: CartItem
}>()

onMounted(() => {
  getPlans()
})

const isLoading = ref(false)
const plans = ref<ExtendPlan[] | null>(null)

const selectedPlan = computed({
  get() {
    return item.warranty?.id || ''
  },
  set(val) {
    if (!plans.value) return

    const plan = plans.value.find((plan) => plan.id === val)
    if (plan) addPlan(plan)
    else removePlan()
  },
})

const planLink = computed(() => {
  if (!plans.value) return
  const plan = plans.value.find((plan) => plan.id === selectedPlan.value)
  return plan?.url
})

const planOptions = computed(() => {
  // Format the dropdown options for FormKit
  return [
    {
      label: 'No Thanks',
      value: '',
    },
    ...(plans.value
      ? plans.value.map((plan) => ({
          label: formatPlanOption(plan),
          value: plan.id,
        }))
      : []),
  ]
})

async function getPlans() {
  plans.value = (await $extend.getPlans(item)) as ExtendPlan[]
}

function formatPlanOption(plan: ExtendPlan) {
  const termLength = plan.contract?.termLength || 0
  const years = termLength / 12

  return `${numberize(years, 'year')} + ${formatCents(plan.price)}`
}

async function addPlan(plan: ExtendPlan) {
  if (isLoading.value) return
  isLoading.value = true

  try {
    await $extend.addWarranty(item, plan)
  } catch (error) {
    // TODO:LATERER Normalize logging errors to bugsnag during cart changes. As part of Jake's future cart refactor
    notifications.addError('Error', 'Unable to add warranty. Please try again later.')
  }

  isLoading.value = false
}

async function removePlan() {
  if (isLoading.value) return
  isLoading.value = true

  try {
    await $extend.removeWarranty(item)
  } catch (error) {
    // TODO:LATERER Normalize logging errors to bugsnag during cart changes. As part of Jake's future cart refactor
    notifications.addError('Error', 'Unable to remove warranty. Please try again later.')
  }

  isLoading.value = false
}

interface ExtendPlan {
  id: string
  contract: {
    termLength: number
  }
  url: string
  price: number
}
</script>
